'use client';

import type { CSSProperties, ReactNode } from 'react';

import styles from './LogoCarousel.module.scss';

interface NewLogoCarouselProps<T extends { id: string }> {
  duration?: number;
  gap?: number;
  items: T[];
  renderItem: (item: T) => ReactNode;
  scrollDirection?: 'left' | 'right';
}

export function LogoCarousel<T extends { id: string }>({
  duration = 90,
  gap = 64,
  items,
  renderItem,
  scrollDirection = 'left',
}: NewLogoCarouselProps<T>) {
  const duplicated: T[] = [
    ...items,
    ...items.map((item) => ({
      ...item,
      id: `${item.id}-clone`,
    })),
  ];

  return (
    <div className={styles.container}>
      <ul
        className={styles.track}
        style={
          {
            '--animationDuration': `${duration}s`,
            '--gap': `${gap}px`,
            '--offset': `calc(-50% - ${gap / 2}px)`,
          } as CSSProperties
        }
        data-scroll-direction={scrollDirection}
      >
        {duplicated.map((item) => renderItem(item))}
      </ul>
    </div>
  );
}
